export const optimizelyFlags = {
  claimOnLivestream: 'enable_claim_on_livestream',
  defaultGuildAnnualMembershipSelection: 'default_guild_annual_membership_selection',
  guildPaymentLink: 'guild_payment_links',
  illuminateLivestreamCTAExperiment: 'illuminate_livestream_cta_experiment',
  letFreedomRingTrailer: 'let_freedom_ring_trailer_experiment',
  sharing_link_input_box: 'sharing_link_input_box',
  sharing_link_pif_vs_tickets_page_experiment: 'sharing_link_pif_vs_tickets_page_experiment',
  siteNavJoinTheGuildExperiment: 'site-nav_join-the-guild_experiment',
  sofTicketsVsPif: 'sof_tickets_vs_pif_experiment',
  sound_of_freedom_guild_two_free_tickets: 'sound_of_freedom_guild_two_free_tickets',
  soundOfFreedomVenueSortingExperiment: 'sound_of_freedom_venue_sorting_experiment',
  guildInfoSoundOfFreedom: 'guild_info_sound_of_freedom',
  hisOnlySonEarlyAccessModal: 'his_only_son_early_access_modal',
  hisOnlySonEarlyAccessModalContentExperiment: 'his_only_son_early_access_modal_content_experiment',
}
